import { parseAriSafely } from '../../../../common/utils';

import { type ValidateImpactedWorkAriResult } from './useValidateImpactedWorkAri';

/**
 * Validates a Townsquare project ARI. Matches the Mercury side, only parsed ARI check
 * Returns 'notFound' immediately if the ARI is not a townsquare resource.
 */
export const useValidateTownsquareProjectAri = (
	ari: string | null,
): ValidateImpactedWorkAriResult => {
	const parsed = ari ? parseAriSafely(ari) : null;
	if (parsed?.resourceOwner !== 'townsquare' || parsed?.resourceType !== 'project') {
		return { status: 'notFound' };
	}
	return { status: 'inWorkspace' };
};
